<ng-select
  [items]="internalItems"
  [loading]="loading"
  [disabled]="disabled"
  [clearable]="clearable"
  [searchable]="true"
  [placeholder]="isFocused || selectedValue ? '' : placeholder"
  [notFoundText]="notFoundText"
  [loadingText]="loadingText"
  [typeToSearchText]="typeahead$ ? typeToSearchText : ''"
  [minTermLength]="minTermLength"
  [typeahead]="typeahead$"
  [compareWith]="compareWith"
  bindLabel="displayName"
  bindValue="id"
  [(ngModel)]="selectedValue"
  (change)="onSelectionChange($event)"
  (clear)="onClear()"
  (open)="onOpen()"
  (close)="onClose()"
  (focus)="onFocus()"
  (blur)="onBlur()"
  appendTo="body"
  class="employee-select"
>
  <!-- Template para as opções do dropdown -->
  <ng-template ng-option-tmp let-item="item">
    <div
      style="
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 12px;
        width: 100%;
        height: 100%;
      "
    >
      <img
        *ngIf="item.profileImagePath"
        [src]="item.profileImagePath"
        style="
          width: 32px;
          height: 32px;
          min-width: 32px;
          min-height: 32px;
          border-radius: 50%;
          object-fit: cover;
          object-position: center;
          flex-shrink: 0;
          overflow: hidden;
        "
        [alt]="item.name"
      />
      <span
        *ngIf="!item.profileImagePath"
        style="
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background-color: #f8f8f8;
          color: #6e6b7b;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        "
      >
        <i data-feather="user" style="font-size: 16px"></i>
      </span>

      <div
        style="display: flex; flex-direction: column; justify-content: center; gap: 2px; flex: 1"
      >
        <span
          style="
            font-size: 14px;
            font-weight: 500;
            color: #5e5873;
            line-height: 1.2;
            margin: 0;
            padding: 0;
          "
          >{{ item.name }}</span
        >
        <span style="font-size: 12px; color: #9c9b9e; line-height: 1.2; margin: 0; padding: 0"
          >MAT: {{ item.registration }}</span
        >
      </div>
    </div>
  </ng-template>

  <!-- Template para o item selecionado -->
  <ng-template ng-label-tmp let-item="item">
    <div class="employee-item employee-item--selected employee-selected-horizontal">
      <img
        *ngIf="item.profileImagePath"
        [src]="item.profileImagePath"
        class="round avatar-img"
        [alt]="item.name"
      />
      <span *ngIf="!item.profileImagePath" class="avatar avatar-img">
        <i data-feather="user" class="font-large-1"></i>
      </span>

      <div class="flex employee-text-container">
        <span class="employee-item--name">{{ item.name }}</span>
        <span class="employee-item--registration">MAT: {{ item.registration }}</span>
      </div>
    </div>
  </ng-template>
</ng-select>
